// DEPRECATED: This file is a duplicate of api.js
// Please use ../utils/api.js instead
// This file is kept for backwards compatibility but will be removed in future versions

import api from './api';

export default api;
